import { Link } from 'react-router-dom';

import type { RegionDetail } from '../../../../api/regions';

import { RegionAreaChips } from './RegionAreaChips';
import { useRegionComponents } from './regionsQueries';

const EM_DASH = '—';

interface Props {
  detail: RegionDetail;
  colorMap: Map<string, string>;
}

/** Populated detail body for a selected region (header, stats, areas, director, edit). */
export function RegionDetailBody({ detail, colorMap }: Props) {
  const compsQ = useRegionComponents(detail.id);
  const color = colorMap.get(detail.id) ?? 'var(--nb-primary)';
  const stats = [
    ['Venues', detail.venueCount],
    ['Subregions', detail.subregionCount],
    ['Areas', detail.componentCount],
  ] as const;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span
          style={{
            width: 11,
            height: 11,
            borderRadius: 3,
            background: color,
          }}
        />
        <span className="nb-display" style={{ fontSize: 17, color: 'var(--nb-bark-dark)' }}>
          {detail.name}
        </span>
        <span className="nb-mono" style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>
          {detail.code || EM_DASH}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 20 }}>
        {stats.map(([label, value]) => (
          <div key={label}>
            <div className="nb-tabular" style={{ fontSize: 18, fontWeight: 700 }}>
              {value}
            </div>
            <div className="nb-eyebrow" style={{ fontSize: 9 }}>
              {label}
            </div>
          </div>
        ))}
      </div>
      <div>
        <div className="nb-eyebrow" style={{ fontSize: 9, marginBottom: 6 }}>
          Composed of
        </div>
        <RegionAreaChips
          areas={compsQ.data ?? []}
          color={color}
          emptyText="No areas yet — composed from subregions."
        />
      </div>

      <div style={{ fontSize: 12, color: 'var(--nb-muted)' }}>
        Director: {detail.directorName ?? EM_DASH}
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <Link
          to={`/admin/regions/${detail.id}`}
          className="nb-btn nb-btn-primary"
          style={{ fontSize: 12, textDecoration: 'none' }}
        >
          View detail
        </Link>
        <Link
          to={`/admin/regions/${detail.id}/edit`}
          className="nb-btn"
          style={{ fontSize: 12, textDecoration: 'none' }}
        >
          Edit in builder
        </Link>
      </div>
    </div>
  );
}
